import { Component, ElementRef, ViewChild, Inject, ɵConsole } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';

import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { ConceptoModel, DefTipoiva } from './Concepto.model';
import { DefOtrconcepId } from './Concepto.model';

import { OpcionModel } from '../Global/Opcion.model';
import { IfObservable } from 'rxjs/observable/IfObservable';

@Component({
	selector: 'conceptoEdit',
	templateUrl: './ConceptoEdit.component.html',
	styleUrls: ['../../../../styles.css']
})


export class ConceptoEditComponent {

	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar: boolean;
	public btnEditar: boolean;
	public btnEliminar: boolean;
	public btnConsultar: boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

	public form: FormGroup;
	public formErrors: any;
	public concepto: ConceptoModel;

	public bloquearLlaves: boolean = false;
	public bloquearLlavesDescripcion: boolean = false;
	public guardando: boolean = false;

	public ccodconTemp: string = '';
	public cnumcontTemp: string = '';
	public ciddocTemp: string = '';
	public ntipoivas = new Array();

	public ocultar: boolean = false;
	public mensaje: string = "";

	constructor(private formBuilder: FormBuilder, private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router: Router, public dialog: MatDialog) {

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

		this.snackBar.dismiss();

		this.formErrors = {

			cdescon: {},
			ccodcon: {},
			cctacxc: {},
			cctaiva: {},
			cingveniva: {},
			nporcentaje: {},
			nporcentajeimpuestoconsumo: {},
			cfidudeb: {},
			ncuentaimpuestoconsumo: {},
			ntipoiva:{},
			cctaprov:{}
		};

		this.ntipoivas = new Array();

		this._serviciosGenerales.get('consultarTiposDeIVA', {param:0}).subscribe(
			result =>{
				for(let x of result){
					this.ntipoivas.push(new OpcionModel(x.ntipoiva, x.vdescripcion));
				}
			}, 
			error =>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos de IVA", "X");
			});

		this.concepto = new ConceptoModel(new DefOtrconcepId("", "", ""), "", "", "", "", "",new DefTipoiva(''),0,0,"",0,"",0)
	}
	
	
	ngOnInit() {
		this.inicializarFormulario("", "", "");

		this._route.params.subscribe(params => {

			this.ccodconTemp = params['ccodcon'];
			this.cnumcontTemp = params['cnumcont'];
			this.ciddocTemp = params['ciddoc'];
			

			if (params['editar'] == 0) {

				this.inicializarFormulario("", "", "");
				this.concepto = new ConceptoModel(new DefOtrconcepId("", params['cnumcont'], params['ciddoc']), "", "", "", "", "", new DefTipoiva(''),0,0,"",0,"",0);

			} else if (params['editar'] == 1) {

				this.bloquearLlaves = true;

				this._serviciosGenerales.get('detalleConcepto', { cnumcont: params['cnumcont'], ccodcon: params['ccodcon'], ciddoc: params['ciddoc'] }).subscribe(
					result => {
						let x = result[0];
						console.log(x);
						this.concepto = new ConceptoModel(new DefOtrconcepId(params['ccodcon'].trim(), params['cnumcont'].trim(), x.ciddoc.trim()), x.cdescon.trim(), x.cctacxc.trim(), x.cctaiva.trim(), x.cingveniva.trim(), x.cfidudeb.trim(),
						new DefTipoiva (x.ntipoiva), x.nporcentaje,x.nporcentajeimpuestoconsumo,x.ncuentaimpuestoconsumo.trim(),x.ncobraimpuestoconsumo,x.cctaprov.trim(),x.bloquear);


						console.log("----- >", parseInt(x.c));
						if (parseInt(x.c) > 0) {
							this.bloquearLlavesDescripcion = true;
						}

						this.inicializarFormulario(this.cnumcontTemp, this.ccodconTemp, x.cdescon.trim());

					}, error => {
						var errorMensaje = <any>error;
						console.log('Error al enviar la peticion ', errorMensaje);
						this.openSnackBarEspecial("Ocurrió un error al momento de cargar el concepto", "X");
					})
			}
		});
	}



	guardar() {

		/*this.concepto.id.ccodcon = this.concepto.id.ccodcon.split(' ').join('');
		this.concepto.cdescon = this.concepto.cdescon.split(' ').join('');
		this.concepto.cctacxc = this.concepto.cctacxc.split(' ').join('');
		this.concepto.cctaiva = this.concepto.cctaiva.split(' ').join('');
		this.concepto.cingveniva = this.concepto.cingveniva.split(' ').join('');*/
		
		
		var regex = new RegExp(/^[A-Za-z0-9]*$/);

		if (regex.test(this.concepto.id.ccodcon) == false) {
			this.openSnackBarEspecial('Codigo de concepto no valido, ingrese un número sin puntos, ni comas, ni guiones, ni espacios , ni letras ', 'X');
			return;
		}


		if (this.concepto.id.ccodcon.split(' ').join('') == ''
			|| this.concepto.cdescon.split(' ').join('') == '') {
			this.openSnackBarEspecial("Hay campos obligatorios por llenar.", "X");
			return;
		}

		if (this.form.valid == false) {
			this.openSnackBarEspecial("Hay campos obligatorios por llenar...", "X");
			return;
		}

		if (this.concepto.nporcentaje > 100) {
			this.openSnackBarEspecial("El porcentaje de IVA no puede ser mayor a 100", "X");
			return;
		}

		if (this.concepto.nporcentaje < 0) {
			this.openSnackBarEspecial("El porcentaje de IVA no puede ser menor a 0", "X");
			return;
		}

		if (this.concepto.nporcentajeimpuestoconsumo > 100) {
			this.openSnackBarEspecial("El porcentaje Impuesto Consumo no puede ser mayor a 100", "X");
			return;
		}

		if (this.concepto.nporcentajeimpuestoconsumo < 0) {
			this.openSnackBarEspecial("El porcentaje de Impuesto Consumo no puede ser menor a 0", "X");
			return;
		}

		if( (this.concepto.deftipoiva.ntipoiva == '0' || this.concepto.deftipoiva.ntipoiva =='2' ) && this.concepto.nporcentaje >0){
			this.openSnackBarEspecial("El tipo de Iva no coincide con el valor de iva diligenciado", "X");
			return;
		}

		if(this.concepto.deftipoiva.ntipoiva == '1' && this.concepto.nporcentaje<=0 ){
			this.openSnackBarEspecial("El tipo de Iva no coincide con el valor de iva diligenciado", "X");
			return;
		}
		if(this.concepto.cdescon.length<5){
			this.openSnackBarEspecial("La descripción del concepto, no debe ser inferior a 5 caracteres", "X");
			return;
		}


		this._serviciosGenerales.get('validacionConcepto', { cnumcont: this.cnumcontTemp, ccodcon: this.concepto.id.ccodcon, ciddoc: this.ciddocTemp }).subscribe(
			result => {

				if (result[0].c > 0 && this.bloquearLlaves == false) {
					this.openSnackBarEspecial("El concepto: " + this.concepto.id.ccodcon + " para el contrato: " + this.cnumcontTemp + " con el prefijo: " + this.ciddocTemp + " ya existe en el sistema", "X");
					return;
				}
				if (result[0].facturas > 0 && this.bloquearLlaves == false) {
					this.openSnackBarEspecial("El concepto: " + this.concepto.id.ccodcon + " para el contrato: " + this.cnumcontTemp + " con el prefijo: " + this.ciddocTemp + " ya fué facturado, no se puede", "X");
					return;
				}

				this.guardarSinValidaciones();

			}, error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar el concepto", "X");
			});
	}




	guardarSinValidaciones() {

		this.concepto.ncobraimpuestoconsumo = (this.concepto.ncobraimpuestoconsumo == true ? 1 : 0);
		this.concepto.bloquear = (this.concepto.bloquear == true ? 1 : 0);

		this.guardando = true;

		this._serviciosGenerales.post('guardar/concepto', this.concepto).subscribe(result => {


			this.openSnackBar("Concepto Guardado correctamente", "X");

			setTimeout(() => {
				this._router.navigate(['/Concepto', this.concepto.id.cnumcont, this.ciddocTemp]);
			}, 2000)



		}, error => {
			var errorMensaje = <any>error;
			console.log('Error al enviar la peticion ', errorMensaje);
			this.openSnackBarEspecial("Ocurrió un error al momento de cargar el concepto", "X");
			this.guardando = false;
		})
	}

	inicializarFormulario(valor1, valor2, valorDescripcion) {



		console.log("VA A INICIALIZAR FORM : ", this.bloquearLlavesDescripcion);
		this.form = this.formBuilder.group({
			cdescon: [{ disabled: this.bloquearLlavesDescripcion, value: valorDescripcion }, Validators.required],
			ccodcon: [{ disabled: this.bloquearLlaves, value: valor2 }, Validators.required],
			cctacxc: ['', Validators.required],
			cctaiva: ['', Validators.required],
			cingveniva: ['', Validators.required],
			ntipoiva: ['',Validators.required],
			nporcentaje: [0, Validators.required],
			nporcentajeimpuestoconsumo: [0, Validators.required],
			cfidudeb: ['', Validators.required],
			ncuentaimpuestoconsumo: ['', Validators.required],
			cctaprov: ['', Validators.required]

		});

		this.form.valueChanges.subscribe(() => {
			this.onFormValuesChanged();
		});
	}


	onFormValuesChanged() {
		for (const field in this.formErrors) {
			if (!this.formErrors.hasOwnProperty(field)) {
				continue;
			}

			// Clear previous errors
			this.formErrors[field] = {};

			// Get the control
			const control = this.form.get(field);

			if (control && control.dirty && !control.valid) {
				this.formErrors[field] = control.errors;
			}
		}
	}

	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}

	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
			console.log("Paso por aqui 1 notas");

			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}

}






// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/CrearConcepto/ConceptoEdit.component.ts